import { ISubmenuStyleData } from "@pageBuilder/typings";
import { ElementStyleService } from "../../../services/element-style.service";

export class SubmenuStyleRenderer {

    constructor(private readonly styleService: ElementStyleService) {}

    public render(element: HTMLElement, style: ISubmenuStyleData): void {
        this.styleService.setStyleObject(element, this.getNavWrapperSelector(element.id), {
            "background": style?.backgroundColor
        });

        this.styleService.setStyleObject(element, this.getNavItemNameNotHoverSelector(element.id), {
            "color": style?.linkColorStyleData?.colorDefault
        });

        this.styleService.setStyleObject(element, this.getNavItemNameHoverSelector(element.id), {
            "color": style.linkColorStyleData?.colorHovered
        });

        this.styleService.setStyleObject(element, this.getActiveNavItemNameSelector(element.id), {
            "color": style.linkColorStyleData?.colorClicked
        });
    }

    private getNavWrapperSelector(id: string): string {
        return `#${id} ul.submenu`;
    }

    private getNavItemNameSelector(id: string): string {
        return `#${id} ul.submenu .nav-item-name`;
    }

    private getNavItemNameHoverSelector(id: string): string {
        return `#${id} ul.submenu .nav-item-name:hover`;
    }

    private getNavItemNameNotHoverSelector(id: string): string {
        return `#${id} ul.submenu .nav-item-name:not(:hover)`;
    }

    private getActiveNavItemNameSelector(id: string): string {
        return `#${id} ul.submenu .active .nav-item-name:not(:hover)`;
    }

    public getStylesSelectors(id: string): string[] {
        return [
            this.getNavWrapperSelector(id),
            this.getNavItemNameSelector(id),
            this.getNavItemNameHoverSelector(id),
            this.getNavItemNameNotHoverSelector(id),
            this.getActiveNavItemNameSelector(id)
        ];
    }

}
